module.exports = __webpack_public_path__ + "img/logo1 (9).c425ff0b.jpg";